module.exports = __webpack_public_path__ + "img/bg_green.8472f7c1.png";